import { motion } from "motion/react";

import { ProductGrid } from "@/theme1/components/product/ProductGrid";

const gridVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

export default function NewInGrid({ products }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-50px" }}
      variants={gridVariants}
    >
      <ProductGrid products={products} />
    </motion.div>
  );
}